import request from '@/utils/request'

// 获取微信配置
export function wxConfig(data){
	return request({
    url: '/admin/Webapi/wxconfig',
    method: 'POST',
    data: data || {}
  })
}
// 统计数据
export function statistics(data){
	return request({
    url: '/admin/Webapi/statistics',
    method: 'POST',
    data: data || {}
  })
}
// 分享统计数据
export function share_log_stat(data){
  return request({
    url: '/api/sharelog/share_log_stat',
    method: 'POST',
    data: data || {}
  })
}